<template>
  <div class="mc-wrapper">
    <div class="mc-container">
      <div class="mc-account">
        <div v-if="isAuth && bonusLoaded" class="mc-account__header">
          <div class="mc-account__header-top">
            <img v-if="bonus.status == 'WHITE' || !bonus.status" class="mc-account__card-image" src="/assets/content/cards/img-1.jpg" width="86" height="54" alt="">
            <img v-if="bonus.status == 'SILVER 10%'" class="mc-account__card-image" src="/assets/content/cards/img-2.jpg" width="86" height="54" alt="">
            <img v-if="bonus.status == 'GOLD 15%'" class="mc-account__card-image" src="/assets/content/cards/img-3.jpg" width="86" height="54" alt="">
            <img v-if="bonus.status == 'PLATINUM 20%'" class="mc-account__card-image" src="/assets/content/cards/img-4.jpg" width="86" height="54" alt="">
            <div class="mc-account__summary">
                                <span class="mc-account__text">
                                    Бонусов: {{bonus.bonus}}
                                </span>
              <router-link to="/loyalty/" class="mc-account__link">
                Правила
              </router-link>
            </div>
          </div>
          <div v-if="false" class="mc-account__header-bottom">
                            <span class="mc-account__text">
                                {{ bonus.status }}
                            </span>
            <div class="mc-account__loading-bar mc-loading-bar" :data-value="bonus.percent+'%'" :style="'--value: '+bonus.percent+'%;'"></div>
            <div class="mc-account__interval">
                                <span class="mc-account__interval-value">
                                   {{ bonus.purchase_amount }}
                                </span>
              <span class="mc-account__interval-value">
                                     {{ bonus.amount_next_status }}
                                </span>
            </div>
          </div>
        </div>
        <ul class="mc-account__menu mc-account-menu">
          <li class="mc-account-menu__item">
            <router-link to="/orders/" class="mc-account-menu__link">
              <svg class="mc-account-menu__link-icon" width="20" height="20" viewBox="0 0 20 20">
                <use xlink:href="/assets/svg/sprite.svg#icon-bag"></use>
              </svg>
              <span class="mc-account-menu__link-title">
                                    Заказы
                                </span>
            </router-link>
          </li>
          <li class="mc-account-menu__item">
            <router-link to="/historybuy/" class="mc-account-menu__link">
              <svg class="mc-account-menu__link-icon" width="20" height="20" viewBox="0 0 20 20">
                <use xlink:href="/assets/svg/sprite.svg#icon-bag"></use>
              </svg>
              <span class="mc-account-menu__link-title">
                                    История покупок
                                </span>
            </router-link>
          </li>
          <li class="mc-account-menu__item">
            <router-link to="/bonus-history/" class="mc-account-menu__link">
              <svg class="mc-account-menu__link-icon" width="20" height="20" viewBox="0 0 20 20">
                <use xlink:href="/assets/svg/sprite.svg#icon-card"></use>
              </svg>
              <span class="mc-account-menu__link-title">
                                    История бонусов
                                </span>
            </router-link>
          </li>
          <li class="mc-account-menu__item">
            <router-link to="/notifications/" class="mc-account-menu__link">
              <svg class="mc-account-menu__link-icon" width="20" height="20" viewBox="0 0 20 20">
                <use xlink:href="/assets/svg/sprite.svg#icon-bell"></use>
              </svg>
              <span class="mc-account-menu__link-title">
                                    Уведомления
                                </span>
            </router-link>
          </li>
          <li class="mc-account-menu__item">
            <router-link to="/favorite/" class="mc-account-menu__link">
              <svg class="mc-account-menu__link-icon" width="20" height="20" viewBox="0 0 20 20">
                <use xlink:href="/assets/svg/sprite.svg#icon-favorite"></use>
              </svg>
              <span class="mc-account-menu__link-title">
                                    Избранное
                                </span>
            </router-link>
          </li>
          <li class="mc-account-menu__item">
            <router-link to="/waiting-list/" class="mc-account-menu__link">
              <svg class="mc-account-menu__link-icon" width="20" height="20" viewBox="0 0 20 20">
                <use xlink:href="/assets/svg/sprite.svg#icon-list"></use>
              </svg>
              <span class="mc-account-menu__link-title">
                                    Лист ожидания
                                </span>
            </router-link>
          </li>
          <li class="mc-account-menu__item">
            <router-link to="/personal/" class="mc-account-menu__link">
              <svg class="mc-account-menu__link-icon" width="20" height="20" viewBox="0 0 20 20">
                <use xlink:href="/assets/svg/sprite.svg#icon-user"></use>
              </svg>
              <span class="mc-account-menu__link-title">
                                    Личные данные
                                </span>
            </router-link>
          </li>
          <li class="mc-account-menu__item">
            <router-link to="/address/" class="mc-account-menu__link">
              <svg class="mc-account-menu__link-icon" width="20" height="20" viewBox="0 0 20 20">
                <use xlink:href="/assets/svg/sprite.svg#icon-home-1"></use>
              </svg>
              <span class="mc-account-menu__link-title">
                                    Адрес доставки
                                </span>
            </router-link>
          </li>
          <li class="mc-account-menu__item">
            <router-link to="/contacts/" class="mc-account-menu__link">
              <svg class="mc-account-menu__link-icon" width="20" height="20" viewBox="0 0 20 20">
                <use xlink:href="/assets/svg/sprite.svg#icon-info"></use>
              </svg>
              <span class="mc-account-menu__link-title">
                                    Контакты
                                </span>
            </router-link>
          </li>
          <li class="mc-account-menu__item">
            <router-link to="/certificates/" class="mc-account-menu__link">
              <svg class="mc-account-menu__link-icon" width="20" height="20" viewBox="0 0 20 20">
                <use xlink:href="/assets/svg/sprite.svg#icon-card"></use>
              </svg>
              <span class="mc-account-menu__link-title">
                                    Подарочные сертификаты
                                </span>
            </router-link>
          </li>
          <li class="mc-account-menu__item">
            <router-link to="/blog/" class="mc-account-menu__link">
              <svg class="mc-account-menu__link-icon" width="20" height="20" viewBox="0 0 20 20">
                <use xlink:href="/assets/svg/sprite.svg#icon-blog"></use>
              </svg>
              <span class="mc-account-menu__link-title">
                                    Блог
                                </span>
            </router-link>
          </li>
          <li class="mc-account-menu__item">
            <router-link to="/boutiques/" class="mc-account-menu__link">
              <svg class="mc-account-menu__link-icon" width="20" height="20" viewBox="0 0 20 20">
                <use xlink:href="/assets/svg/sprite.svg#icon-store"></use>
              </svg>
              <span class="mc-account-menu__link-title">
                                    Бутики
                                </span>
            </router-link>
          </li>
          <li class="mc-account-menu__item">
            <router-link to="/info/" class="mc-account-menu__link">
              <svg class="mc-account-menu__link-icon" width="20" height="20" viewBox="0 0 20 20">
                <use xlink:href="/assets/svg/sprite.svg#icon-info-1"></use>
              </svg>
              <span class="mc-account-menu__link-title">
                                    Информация
                                </span>
            </router-link>
          </li>
        </ul>
        <div class="mc-account__bottom">
          <button @click="logout" class="mc-button simulated-hover" type="button">
                            <span class="mc-button__text">
                                Выход из аккаунта
                            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import checkAuth from '../mixin/checkAuth';
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {

  },
  mixins: [checkAuth],
  beforeRouteLeave(to, from) {
    //if (to.name != 'login')
    //  this.$store.dispatch('unLoader');
  },
  created() {

  },
  computed: {
      ...mapGetters([
        'bonus',
        'bonusLoading',
        'bonusError',
        'bonusLoaded',
        'isAuth'
      ])
  },
  async mounted() {

  },
  methods: {
    async logout() {
      await this.$store.dispatch('logout');
      this.$router.push('/auth/');
    }
  },
  data: () => ({
    error: [],
    sending: false,
    error_text: [],
  phone: '',
    code: '',
    step: 1
  }),
}
</script>
